import React from "react";
import { useBlocks } from "@jelly/lesson";
import styles from "./Page01.module.scss";

type singleBlockData = {
  description: string;
  samples: Array<{ title: string; src: string }>;
  buttonLabel: string;
};

export interface Lesson0208Page01Props {
  example1: singleBlockData;
  example2: singleBlockData;
}

export const Lesson0208Page01: React.FC<Lesson0208Page01Props> = (props) => {
  const block = useBlocks();

  function renderBlock(data: singleBlockData): React.ReactNode {
    return (
      <div className={styles.blockWrapper}>
        <div className={styles.descriptionWrapper}>
          <p>{data.description}</p>
        </div>
        <div className={styles.audioWrapper}>
          <block.audioSlider samples={data.samples} buttonLabel={data.buttonLabel} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.blocksWrapper}>
        {renderBlock(props.example1)}
        {renderBlock(props.example2)}
      </div>
    </div>
  );
};
